/**
 * Seasonal look of the entry screens (login, welcome, application pages).
 *
 *  'pumpkin' - cream paper colour with the drawn pumpkin behind the page (fall 2026)
 *  'heart'   - the pink background with the drawn heart under the login / welcome box
 *
 * The heart look is kept as it was: set SEASON_LOOK = 'heart' to bring it back.
 * Pictures: public/decorations/pumpkin-portrait.jpg (phones), pumpkin-landscape.jpg (wider screens);
 * colours and placement: src/styles/pumpkin-background.css.
 */
export type SeasonLook = 'pumpkin' | 'heart'

export const SEASON_LOOK: SeasonLook = 'pumpkin'

import { loginColors } from './loginConfig'
import { welcomeColors } from './welcomeConfig'

/** Login screen colours: the pumpkin look gives "enter" and "send login code" pumpkin orange */
export const entryLoginColors = SEASON_LOOK === 'pumpkin'
  ? {
      ...loginColors,
      loginButtonBackground: 'bg-[#F6B26B]', // "enter": soft pumpkin orange
      loginButtonHover: 'hover:bg-[#EFA052]',
      loginButtonText: 'text-black',
      submitButtonBackground: 'bg-[#E07B39]', // "send login code": deeper pumpkin orange
      submitButtonHover: 'hover:bg-[#CC6A2C]',
      submitButtonText: 'text-white',
    }
  : loginColors

/** Welcome screen colours: the pumpkin look gives its buttons the same pumpkin orange as "enter" */
export const entryWelcomeColors = SEASON_LOOK === 'pumpkin'
  ? {
      ...welcomeColors,
      buttonBackground: 'bg-[#F6B26B]',
      buttonHover: 'hover:bg-[#EFA052]',
      buttonText: 'text-black',
    }
  : welcomeColors

/** Small text links on the entry screens (e.g. the mailbox "click me") */
export const entryLinkText = SEASON_LOOK === 'pumpkin'
  ? 'text-[#E07B39] hover:text-[#CC6A2C]'
  : 'text-pink-400 hover:text-pink-500'

/** The page background class: the season's colour, or the given pink class for the heart look */
export function seasonPageBackground(heartClass: string): string {
  return SEASON_LOOK === 'pumpkin' ? 'pumpkin-page' : heartClass
}
